import { Column, Index, JoinColumn, ManyToOne } from 'typeorm';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';
import { MSmClientOpportunityEntity } from './m-sm-client-opportunity.entity';
import { OrderEntity } from './order.entity';

/**
 * PD-17328 — a quote on an opportunity. An opportunity can hold several (a
 * base bid and alternates); one is the primary, the one the summary and the
 * bid comparison use. The opportunity's own m_sm_fk_order__id is kept equal
 * to the primary, so the legacy CRM, which reads that column, still sees it.
 *
 * SM1 exposure: none (a new table).
 */
@Index('opportunity_quote__opportunity_order', ['fkOpportunityId', 'fkOrderId'], { unique: true })
@Index('opportunity_quote__fk_order__id', ['fkOrderId'], {})
@Entity('opportunity_quote')
export class OpportunityQuoteEntity extends BaseEntity {
	@Column('int', { name: 'fk_m_sm_client_opportunity__id', unsigned: true })
	public fkOpportunityId!: number;

	@Column('int', { name: 'fk_order__id', unsigned: true })
	public fkOrderId!: number;

	@Column({ type: 'boolean', name: 'isPrimary', width: 1, default: () => "'0'" })
	public isPrimary!: boolean;

	/** What the quote is in the pursuit ("Base bid", "Alternate 1"). */
	@Column('varchar', { name: 'label', length: 100, nullable: true })
	public label!: string | null;

	@ManyToOne(() => MSmClientOpportunityEntity, { onDelete: 'CASCADE', onUpdate: 'RESTRICT' })
	@JoinColumn([{ name: 'fk_m_sm_client_opportunity__id', referencedColumnName: 'id' }])
	public opportunity!: MSmClientOpportunityEntity;

	@ManyToOne(() => OrderEntity, { onDelete: 'CASCADE', onUpdate: 'RESTRICT' })
	@JoinColumn([{ name: 'fk_order__id', referencedColumnName: 'id' }])
	public order!: OrderEntity;
}
